import React from "react";
import BackLink from "../components/BackLink";
import { Col, Container, Row } from "react-bootstrap";
import JourneyProgress from "../components/JourneyProgress";
import BookingForm from "../components/BookUnit/BookingForm";
import Countdown from "../components/Countdown";

function BookUnit() {
  return (
    <>
      <BackLink desktop />
      <Row>
        <Col xs={0} sm={0} md={0} lg={3}>
          &nbsp;
        </Col>
        <Col xs={12} sm={12} md={12} lg={6}>
          <JourneyProgress mobile className={"mt-2"} />
          <Countdown minutes={20} seconds={0} />
          <Container className={"phone-container"}>
            <BookingForm />
          </Container>
        </Col>
      </Row>
    </>
  );
}

export default BookUnit;
